import { createSelector } from 'reselect';
import { IDesallStore } from './DesallStore';

const getDesallState = (state: IDesallStore) => state;

export const getMobileMode = createSelector(getDesallState, (state) => state.mobileMode);
export const getTimeLeft = createSelector(getDesallState, (state) => state.timeLeft);
export const getPortfolioDesignNames = createSelector(getDesallState, (state) => state.portfolioDesignNames);
export const getSocialUser = createSelector(getDesallState, (state) => state.socialUser);
export const getSocialResolve = createSelector(getDesallState, (state) => state.socialResolve);